import gql from 'graphql-tag';

export const BLOCKED_USERS = gql`
 query blockedUsers($userId: String, $searchVal: String) {
    blockedUsers(userId: $userId, searchVal: $searchVal) {
        id
        blockedUser {
            id
            firstName
            lastName
            profile {
                nickName
            }
        }
        blockedBy {
            id
        }
    }
 }
`

export const BLOCKED_BY_USERS = gql`
 query blockedByUsers($userId: String!) {
    blockedByUsers(userId: $userId) {
        id
        blockedUser {
            id
        }
        blockedBy {
            id
        }
    }
 }
`

export const CREATE_BLOCKED_USER = gql`
 mutation createBlockedUser($data: BlockedUserInput) {
    createBlockedUser(data: $data) {
        id
    }
 }
`

export const DELETE_BLOCKED_USER = gql`
 mutation deleteBlockedUser($id: String!) {
    deleteBlockedUser(id: $id)
 }
`